import { useState } from "react";
import { Button, Form, Input, Row, message } from "antd";

import classes from "./Password.module.css";
import { updateUserPassword } from "api/userData";
import { useForm } from "@refinedev/antd";

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 8 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 16 },
	},
};

const submit = async (values: {
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
}) => {
	const { currentPassword, newPassword, confirmPassword } = values;

	if (!currentPassword || !newPassword || !confirmPassword) {
		message.error("Please fill in all fields");
		return;
	}

	if (newPassword !== confirmPassword) {
		message.error("Passwords do not match");
		return;
	}

	const res = await updateUserPassword({ currentPassword, newPassword });
	if (res) {
		message.success("Password updated successfully");
	}
};

export const Password = () => {
	const [values, setValues] = useState({
		currentPassword: "",
		newPassword: "",
		confirmPassword: "",
	});
	const [loading, setLoading] = useState(false);

	return (
		<Row className={classes.jobsContainer}>
			<Row className={classes.container}>
				<Form {...formItemLayout}>
					<Form.Item
						name="currentPassword"
						className={classes.inputName}
					>
						Current password
						<Input.Password
							className={classes.passwordInput}
							value={values.currentPassword}
							onChange={(e) =>
								setValues({
									...values,
									currentPassword: e.target.value,
								})
							}
						/>
					</Form.Item>

					<Form.Item name="newPassword" className={classes.inputName}>
						New password
						<Input.Password
							className={classes.passwordInput}
							value={values.newPassword}
							onChange={(e) =>
								setValues({
									...values,
									newPassword: e.target.value,
								})
							}
						/>
					</Form.Item>

					<Form.Item
						name="confirmPassword"
						className={classes.inputName}
					>
						Re-type new password
						<Input.Password
							className={classes.passwordInput}
							value={values.confirmPassword}
							onChange={(e) =>
								setValues({
									...values,
									confirmPassword: e.target.value,
								})
							}
						/>
					</Form.Item>
					<Button
						loading={loading}
						disabled={loading}
						className={classes.saveButton}
						onClick={() => {
							submit(values);
						}}
					>
						Save Changes
					</Button>
				</Form>
			</Row>
		</Row>
	);
};
